export default __webpack_public_path__ + "static/media/prity-black.cb797fae.jpeg";